import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/auth';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER = 'Authorization';

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // FormData bodies must keep the browser-generated multipart Content-Type (with its boundary), so
    // only default to JSON for non-FormData requests.
    if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    }

    if (req.url === '/session') {
      return next.handle(req);
    }

    if (this.isBrokerSessionRequest(req.url)) {
      return next.handle(req.clone({ withCredentials: true }));
    }

    if (req.url.includes('unsplash')) {
      const authReq = req.clone({
        headers: req.headers.set(this.AUTH_HEADER, `Client-ID ${environment.unsplashConfig.access}`)
      });

      return next.handle(authReq);
    }

    const jwtToken = this.authService.accessToken;
    if (!jwtToken) {
      return next.handle(req);
    }

    const authReq = req.clone({
      headers: req.headers.set(this.AUTH_HEADER, `Bearer ${jwtToken}`)
    });

    return next.handle(authReq);
  }

  private isBrokerSessionRequest(url: string): boolean {
    return url === '/organizations' || url.startsWith('/account/');
  }
}
